<template>
  <div class="va-row role-color-picker-wrapper">
      <label
        class="control-label text-capitalize flex md5 input-group association-color-wrapper pt-3"
        for="association-color"
      >{{$t(`roleColorPicker.association`)}}:</label>
      <vuestic-color-picker-input
        class="flex md3 pt-3" v-show="!!selectedColor && selectedColor!='none'"
        ref="picker"
        v-model="selectedColor"
        mode="palette"
        :palette="colorsArray"
      >
        <color-dot :color="selectedColor" />
      </vuestic-color-picker-input>
    <span
      v-show="!!selectedColor && selectedColor!='none'"
      @click="selectedColor='none'"
      class="entypo entypo-cancel action-hover small-text md2 custom-top-padding"
    ></span>
    <div
      v-show="!selectedColor || selectedColor=='none'"
      @click="setColor"
      ref="toggleRef"
      class="action-hover md2 custom-top-padding custom-font-size"
    >{{$t('roleColorPicker.noGroup')}}</div>
  </div>
  <!-- </div> -->
</template>

<script>
import { allColorsArray } from "../../vuestic-theme/vuestic-components/vuestic-color-picker/VuesticTheme";
import VuesticColorPickerInput from "../../vuestic-theme/vuestic-components/vuestic-color-picker/VuesticColorPickerInput";
import ColorDot from "../../vuestic-theme/vuestic-components/vuestic-color-picker/ColorDot";

export default {
  name: "role-color-picker",
  props: {
    value: {
      default: "none"
    },
    colorsArray: {
      default: () => allColorsArray
    }
  },
  components: {
    VuesticColorPickerInput,
    ColorDot
  },
  computed: {
    selectedColor: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    setColor() {
      this.selectedColor = this.colorsArray[0];
      this.$nextTick(() => {
        this.$refs.picker.$children[0].toggle();
      });
    }
  }
};
</script>

<style lang="scss">
.role-color-picker-wrapper {
  .association-color-wrapper {
    color: #4ae387;
    font-size: 1.1rem !important;
  }

  .action-hover:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .custom-top-padding {
    padding-top: 0.75rem;
  }

  .custom-font-size{
    font-size: 1.345rem;
  }
}
</style>
